
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerServiceWorker } from './registerSW';
import type { BeforeInstallPromptEvent } from './types/pwa';

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker after the app has loaded
window.addEventListener('load', () => {
  registerServiceWorker();
  
  // Add event listener for beforeinstallprompt to provide custom install experience if needed
  window.addEventListener('beforeinstallprompt', (e: Event) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later if needed
    window.deferredPrompt = e as BeforeInstallPromptEvent;
    console.log('App can be installed, saved prompt for later');
  });
});
